/**
 * In-memory mirror of the user's Optimizely experiment assignments
 * (experimentName -> variation), kept so the non-React attribution calls
 * (lead-capture / purchase) can attach them without prop-drilling. Client-only;
 * populated from OptimizelyContext by useExperimentAssignmentsCapture.
 */

export type ExperimentAssignments = Record<string, string>

let storedExperiments: ExperimentAssignments = {}

/** Stores the latest assignment map. Ignores empty maps (never clears). */
export function setExperiments(experiments: ExperimentAssignments | null | undefined): void {
  // Client-only: the module global is shared across requests on the server.
  if (typeof window === 'undefined') return
  if (experiments && Object.keys(experiments).length > 0) {
    storedExperiments = experiments
  }
}

/** Reads the current assignments, or null when none have been captured. */
export function getExperiments(): ExperimentAssignments | null {
  return Object.keys(storedExperiments).length > 0 ? storedExperiments : null
}

/** Test-only: reset the in-memory store. */
export function resetExperiments(): void {
  storedExperiments = {}
}
